// extracted by mini-css-extract-plugin
export default {"mainCont":"OrderHistory_mainCont__9PBVa","TableDiv":"OrderHistory_TableDiv__RzPrO"};